function ArrowControls (Glide) {
    const CLASSES = Glide.settings.arrowClasses;
    const GLIDE_PARENT = Glide.selector;
    const BACK_ARROW = GLIDE_PARENT.querySelector('.' + CLASSES.back);
    const NEXT_ARROW = GLIDE_PARENT.querySelector('.' + CLASSES.next);

    return {
        mount() {
        BACK_ARROW.addEventListener('click', function() { Glide.go('<'); });
        NEXT_ARROW.addEventListener('click', function() { Glide.go('>'); });
        }
    }
}

module.exports = { ArrowControls }